/* MyAgency EE redesign: shared behaviour for mma-* sections */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.mma .rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
  }
  function marquee(root) {
    (root || document).querySelectorAll('.mma [data-marquee]').forEach(function (t) {
      if (t.dataset.done) return; t.dataset.done = '1';
      Array.prototype.slice.call(t.children).forEach(function (c) { var d = c.cloneNode(true); d.setAttribute('aria-hidden', 'true'); d.alt = ''; t.appendChild(d); });
    });
  }
  function rails() {
    document.querySelectorAll('.mma [data-rail]').forEach(function (steps) {
      var bar = steps.querySelector('.rail i'); if (!bar) return;
      var r = steps.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (innerHeight * 0.6 - r.top) / r.height));
      bar.style.setProperty('--p', (p * 100).toFixed(1) + '%');
    });
  }
  function header() {
    document.querySelectorAll('.mma header.site').forEach(function (h) { h.classList.toggle('scrolled', scrollY > 8); });
  }
  function burgers(root) {
    (root || document).querySelectorAll('.mma .burger').forEach(function (b) {
      if (b.dataset.done) return; b.dataset.done = '1';
      b.addEventListener('click', function () {
        var m = document.getElementById(b.getAttribute('aria-controls'));
        var open = m.classList.toggle('open'); b.setAttribute('aria-expanded', open);
      });
    });
  }

  function coverflow(root) {
    (root || document).querySelectorAll('.mma [data-coverflow]').forEach(function (cf) {
      if (cf.dataset.done) return; cf.dataset.done = '1';
      var cards = Array.prototype.slice.call(cf.querySelectorAll('.cf-card'));
      var dots = Array.prototype.slice.call(cf.querySelectorAll('[data-dot]'));
      var modal = cf.querySelector('.cf-modal'), panel = cf.querySelector('.cf-panel'), content = cf.querySelector('.cf-content');
      var n = cards.length, active = 0, timer = null, paused = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!n) return;
      function layout() {
        var w = cf.clientWidth, cw = Math.max(220, Math.min(340, w * 0.26));
        if (w < 820) cw = Math.min(260, w * 0.62);
        cf.style.setProperty('--cw', cw + 'px');
        cf.style.height = Math.round(cw * 4 / 3 + (w < 820 ? 86 : 60)) + 'px';
        var gap = w < 820 ? cw * 0.42 : cw * 0.62;
        cards.forEach(function (c, i) {
          var d = ((i - active) % n + n) % n; if (d > n / 2) d -= n;
          var a = Math.abs(d), sign = d < 0 ? -1 : 1;
          var x = d === 0 ? 0 : sign * (cw * 0.62 + (a - 1) * gap);
          var tf = 'translateX(' + x + 'px) translateZ(' + (-a * 160) + 'px) rotateY(' + (-sign * Math.min(a, 1) * 38) + 'deg) scale(' + (d === 0 ? 1 : 0.92) + ')';
          c.style.transform = tf;
          c.style.zIndex = 20 - a;
          c.style.opacity = a > 2 ? 0 : 1;
          c.style.pointerEvents = a > 2 ? 'none' : '';
          c.classList.toggle('is-active', d === 0);
          c.setAttribute('aria-hidden', a > 2 ? 'true' : 'false');
          c.tabIndex = d === 0 ? 0 : -1;
        });
        dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === active); });
      }
      function go(i) { active = (i % n + n) % n; layout(); }
      function play() { stop(); if (cf.dataset.autoplay !== 'false' && !reduce && !paused) timer = setInterval(function () { go(active + 1); }, 3600); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      function fill(i) {
        var t = cf.querySelector('template[data-profile="' + i + '"]');
        content.innerHTML = ''; content.appendChild(t.content.cloneNode(true)); content.scrollTop = 0;
      }
      function open(i) {
        fill(i); paused = true; stop();
        var from = cards[i].getBoundingClientRect();
        modal.showModal();
        var to = panel.getBoundingClientRect();
        if (!reduce && panel.animate) {
          panel.animate([
            { transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + (from.width / to.width) + ',' + (from.height / to.height) + ')', borderRadius: '24px', opacity: .4 },
            { transform: 'none', opacity: 1 }
          ], { duration: 460, easing: 'cubic-bezier(.2,.7,.2,1)' });
        }
      }
      function close() {
        if (!modal.open) return;
        var done = function () { modal.close(); paused = false; play(); cards[active].focus({ preventScroll: true }); };
        if (!reduce && panel.animate) {
          var from = cards[active].getBoundingClientRect(), to = panel.getBoundingClientRect();
          var an = panel.animate([{ transform: 'none', opacity: 1 }, { transform: 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + (from.width / to.width) + ',' + (from.height / to.height) + ')', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.4,0,.2,1)' });
          an.onfinish = done;
        } else done();
      }
      cards.forEach(function (c, i) { c.addEventListener('click', function () { if (swiped) { swiped = false; return; } if (i === active) open(i); else go(i); }); });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      cf.querySelector('.cf-nav.prev').addEventListener('click', function () { go(active - 1); });
      cf.querySelector('.cf-nav.next').addEventListener('click', function () { go(active + 1); });
      cf.querySelector('.cf-close').addEventListener('click', close);
      cf.querySelector('.cf-mprev').addEventListener('click', function () { go(active - 1); fill(active); });
      cf.querySelector('.cf-mnext').addEventListener('click', function () { go(active + 1); fill(active); });
      modal.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      cf.addEventListener('mouseenter', function () { paused = true; stop(); });
      cf.addEventListener('mouseleave', function () { if (!modal.open) { paused = false; play(); } });
      cf.addEventListener('focusin', function () { paused = true; stop(); });
      cf.addEventListener('keydown', function (e) {
        if (modal.open) return;
        if (e.key === 'ArrowLeft') { go(active - 1); cards[active].focus(); }
        if (e.key === 'ArrowRight') { go(active + 1); cards[active].focus(); }
      });
      var sx = null, swiped = false;
      cf.addEventListener('pointerdown', function (e) { if (!modal.open) sx = e.clientX; });
      cf.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx; sx = null; swiped = Math.abs(dx) > 40; if (swiped) go(active + (dx < 0 ? 1 : -1)); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) play(); else stop(); }); }).observe(cf);
      addEventListener('resize', layout);
      layout();
    });
  }

  function pdp(root) {
    (root || document).querySelectorAll('[data-pdp]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var main = w.querySelector('.main-img img');
      w.querySelectorAll('[data-thumbs] button').forEach(function (b, i, all) {
        b.addEventListener('click', function () {
          if (!main) return; main.style.opacity = 0;
          setTimeout(function () { main.removeAttribute('srcset'); main.src = b.dataset.src; main.alt = b.dataset.alt; main.style.opacity = 1; }, 160);
          all.forEach(function (x) { x.setAttribute('aria-current', x === b); });
        });
      });
      var qty = w.querySelector('[data-qty]');
      w.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { qty.value = Math.max(1, Math.min(9, (+qty.value || 1) + +b.dataset.q)); }); });
      var stick = w.querySelector('[data-stick]'), box = w.querySelector('#buyBox');
      if (stick && box && 'IntersectionObserver' in window) new IntersectionObserver(function (es) {
        var e = es[0], show = !e.isIntersecting && e.boundingClientRect.top < 0;
        stick.classList.toggle('on', show); stick.setAttribute('aria-hidden', !show);
      }).observe(box);
    });
    (root || document).querySelectorAll('.mma [data-related]').forEach(function (r) {
      if (r.dataset.done || r.children.length) return; r.dataset.done = '1';
      fetch(r.dataset.url).then(function (x) { return x.text(); }).then(function (h) {
        var d = document.createElement('div'); d.innerHTML = h;
        var inner = d.querySelector('[data-related]'); if (inner && inner.innerHTML.trim()) { r.innerHTML = inner.innerHTML; reveal(r); }
      }).catch(function () {});
    });
  }

  function blogs(root) {
    (root || document).querySelectorAll('.mma [data-filters]').forEach(function (f) {
      if (f.dataset.done) return; f.dataset.done = '1';
      var grid = f.parentNode.querySelector('[data-grid]'), btns = f.querySelectorAll('button');
      btns.forEach(function (b) { b.addEventListener('click', function () {
        var k = b.dataset.f, n = 0;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        grid.querySelectorAll('.post').forEach(function (p) { var show = k === 'all' || p.dataset.tags.indexOf('|' + k + '|') > -1; p.hidden = !show; if (show) { n++; p.classList.add('in'); } });
        var promo = grid.querySelector('[data-promo]'); if (promo) promo.hidden = k !== 'all';
        grid.querySelector('[data-empty]').hidden = n > 0;
      }); });
    });
    (root || document).querySelectorAll('[data-article]').forEach(function (a) {
      if (a.dataset.done) return; a.dataset.done = '1';
      var prose = a.querySelector('[data-prose]'), toc = a.querySelector('[data-toc]'), bar = a.querySelector('[data-progress]');
      prose.querySelectorAll('p').forEach(function (pp) { var st = pp.querySelector('strong, b'); if (st && pp.children.length === 1 && pp.textContent.trim() === st.textContent.trim() && st.textContent.trim().length < 90) pp.classList.add('as-h'); });
      var heads = Array.prototype.slice.call(prose.querySelectorAll('h2, h3, p.as-h'));
      if (heads.length < 2) { a.querySelector('[data-toc-wrap] > b').style.display = 'none'; }
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'section-' + (i + 1);
        if (heads.length < 2) return;
        var li = document.createElement('li'), l = document.createElement('a');
        l.href = '#' + h.id; l.textContent = h.textContent.trim(); li.appendChild(l); toc.appendChild(li);
      });
      var links = toc.querySelectorAll('a');
      function onScroll() {
        var r = prose.getBoundingClientRect(), p = Math.min(1, Math.max(0, -r.top / (r.height - innerHeight * 0.6)));
        if (bar) bar.style.width = (p * 100) + '%';
        var cur = -1; heads.forEach(function (h, i) { if (h.getBoundingClientRect().top < 160) cur = i; });
        links.forEach(function (l, i) { l.classList.toggle('on', i === cur); });
      }
      addEventListener('scroll', onScroll, { passive: true }); onScroll();
      var c = a.querySelector('[data-copy]');
      if (c) c.addEventListener('click', function () { var done = function () { c.innerHTML = '&#10003;'; setTimeout(function () { c.innerHTML = '&#128279;'; }, 1500); }; try { navigator.clipboard.writeText(c.dataset.copy).then(done, done); } catch (e) { done(); } });
    });
  }

  function crews(root) {
    (root || document).querySelectorAll('[data-crew-wrap]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var m = w.querySelector('.crew-modal'), c = m.querySelector('.cf-content');
      w.querySelectorAll('[data-crew]').forEach(function (b) { b.addEventListener('click', function () {
        c.innerHTML = ''; c.appendChild(w.querySelector('template[data-crew-profile="' + b.dataset.crew + '"]').content.cloneNode(true)); m.showModal();
      }); });
      m.querySelector('.cf-close').addEventListener('click', function () { m.close(); });
      m.addEventListener('click', function (e) { if (e.target === m) m.close(); });
    });
  }
  function dltabs(root) {
    (root || document).querySelectorAll('[data-dltabs]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var tabs = w.querySelectorAll('.tab'), panels = w.querySelectorAll('[data-panel]'), ti = 0, timer = null;
      function show(i) { ti = i; tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i); }); panels.forEach(function (p, j) { p.hidden = j !== i; }); }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); clearInterval(timer); }); });
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(function () { show((ti + 1) % tabs.length); }, 6000);
    });
  }
  function rcshop(root) {
    (root || document).querySelectorAll('[data-rcshop]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var chips = w.querySelectorAll('[data-f]'), cards = w.querySelectorAll('.gcard'), up = w.querySelector('[data-upsell]');
      chips.forEach(function (b) { b.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        var f = b.dataset.f;
        cards.forEach(function (c) { c.hidden = f !== 'all' && (' ' + c.dataset.cat + ' ').indexOf(' ' + f + ' ') < 0; });
        if (up) up.hidden = f !== 'all';
      }); });
    });
    var bar = document.querySelector('.mma [data-cartbar]');
    (root || document).querySelectorAll('.mma [data-add-ids]').forEach(function (b) {
      if (b.dataset.done) return; b.dataset.done = '1';
      b.addEventListener('click', function () {
        var items = b.dataset.addIds.split(',').map(function (id) { return { id: +id, quantity: 1 }; });
        var label = b.textContent; b.disabled = true; b.textContent = 'Adding...';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); }).then(function (r) { return r.json(); }).then(function (c) {
            b.textContent = 'Added ✓'; b.classList.add('done'); b.disabled = false;
            setTimeout(function () { b.textContent = label; b.classList.remove('done'); }, 2500);
            document.querySelectorAll('.mma header.site .cart').forEach(function (a) { var s = a.querySelector('.count'); if (!s) { s = document.createElement('span'); s.className = 'count'; a.appendChild(s); } s.textContent = c.item_count; });
            if (bar) {
              bar.querySelector('[data-ct]').textContent = b.dataset.name + ' added';
              var money = (c.total_price / 100).toLocaleString('en-NZ', { style: 'currency', currency: c.currency || 'NZD' }).replace('NZ$', '$');
              bar.querySelector('[data-sub]').textContent = c.item_count + (c.item_count === 1 ? ' item' : ' items') + ' in cart, ' + money + (bar.dataset.nudge && c.item_count >= 2 ? '. ' + bar.dataset.nudge : '');
              bar.classList.add('on'); clearTimeout(bar._t); bar._t = setTimeout(function () { bar.classList.remove('on'); }, 6000);
            }
          }).catch(function () { b.disabled = false; b.textContent = label; window.location.href = '/cart'; });
      });
    });
  }
  // rcshop end
  function hubnav(root) {
    var bar = document.querySelector('.mma [data-hubnav]');
    if (!bar || bar.dataset.done) return; bar.dataset.done = '1';
    var chaps = Array.prototype.slice.call(document.querySelectorAll('.mma [data-chap]'));
    if (!chaps.length) return;
    var links = bar.querySelectorAll('a'), box = bar.querySelector('.in');
    function top() { var h = document.querySelector('.mma-sticky') || document.querySelector('.mma header.site'); bar.style.setProperty('--hub-top', (h ? Math.max(0, h.getBoundingClientRect().bottom) : 0) + 'px'); }
    function update() {
      top();
      var first = chaps[0].getBoundingClientRect(), last = chaps[chaps.length - 1].getBoundingClientRect(), mid = innerHeight * 0.45;
      bar.classList.toggle('show', first.top < 140 && last.bottom > 160);
      var cur = null; chaps.forEach(function (c) { var r = c.getBoundingClientRect(); if (r.top < mid && r.bottom > mid) cur = c.id; });
      links.forEach(function (a) { var on = a.getAttribute('href') === '#' + cur; if (on && !a.classList.contains('on')) box.scrollTo({ left: a.offsetLeft - box.clientWidth / 2 + a.clientWidth / 2, behavior: 'smooth' }); a.classList.toggle('on', on); });
    }
    addEventListener('scroll', update, { passive: true }); addEventListener('resize', update); update();
  }
  // hubnav end
  function gcui(root) {
    (root || document).querySelectorAll('.mma [data-road]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var tabs = w.querySelectorAll('.mstep'), panels = w.querySelectorAll('.road-panel');
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i); }); panels.forEach(function (p, j) { p.hidden = j !== i; }); }); });
    });
    (root || document).querySelectorAll('.mma [data-ffaq]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var bs = w.querySelectorAll('.ftabs button'), qs = w.querySelectorAll('.qa');
      bs.forEach(function (b) { b.addEventListener('click', function () { bs.forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); qs.forEach(function (q) { q.hidden = b.dataset.f !== 'all' && q.dataset.c !== b.dataset.f; }); }); });
    });
    (root || document).querySelectorAll('.mma [data-copy]').forEach(function (b) {
      if (b.dataset.done) return; b.dataset.done = '1';
      b.addEventListener('click', function () { var done = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy'; }, 1500); }; try { navigator.clipboard.writeText(b.dataset.copy).then(done, function () {}); } catch (e) {} });
    });
  }
  // gcui end
  function pkqual(root) {
    (root || document).querySelectorAll('.mma [data-qual]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var items = Array.prototype.slice.call(w.querySelectorAll('[data-q]')), v = w.querySelector('[data-verdict]');
      items.forEach(function (li) {
        li.addEventListener('click', function () {
          li.classList.toggle('on'); li.setAttribute('aria-checked', li.classList.contains('on'));
          var n = items.filter(function (x) { return x.classList.contains('on'); }).length;
          if (v) v.textContent = n === items.length ? v.dataset.yes : (n ? n + ' of ' + items.length + ' ticked.' : '');
        });
        li.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); li.click(); } });
      });
    });
  }
  // pkqual end
  function wegal(root) {
    (root || document).querySelectorAll('.mma [data-gtabs]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var bs = w.querySelectorAll('[role=tab]'), gs = w.querySelectorAll('[data-gal]');
      bs.forEach(function (b, i) { b.addEventListener('click', function () { bs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i); }); gs.forEach(function (g, j) { g.hidden = j !== i; }); }); });
    });
  }
  // wegal end
  function bsui(root) {
    (root || document).querySelectorAll('.mma [data-bstabs]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var bs = w.querySelectorAll('[role=tab]'), ps = w.querySelectorAll('[data-pane]');
      bs.forEach(function (b, i) { b.addEventListener('click', function () { bs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i); }); ps.forEach(function (p, j) { p.hidden = j !== i; }); }); });
    });
    (root || document).querySelectorAll('.mma [data-fc]').forEach(function (fc) {
      if (fc.dataset.done) return; fc.dataset.done = '1';
      var g = function (n) { return fc.querySelector('[name=' + n + ']'); }, fmt = function (n) { return '$' + Math.round(n).toLocaleString('en-NZ'); };
      var base = (+g('t').defaultValue) * (+g('c').defaultValue) / 100 * (+g('a').defaultValue);
      var up = function () { var t = +g('t').value, c = +g('c').value, a = +g('a').value;
        fc.querySelector('[data-o=t]').textContent = t.toLocaleString('en-NZ'); fc.querySelector('[data-o=c]').textContent = c.toFixed(1) + '%'; fc.querySelector('[data-o=a]').textContent = fmt(a);
        var r = t * c / 100 * a, d = (r / base - 1) * 100; fc.querySelector('[data-r]').textContent = fmt(r); fc.querySelector('[data-d]').textContent = (d >= 0 ? '+' : '') + Math.round(d) + '% vs today'; };
      fc.querySelectorAll('input').forEach(function (i) { i.addEventListener('input', up); }); up();
    });
  }
  // bsui end
  function trui(root) {
    (root || document).querySelectorAll('.mma [data-chooser]').forEach(function (w) {
      if (w.dataset.done) return; w.dataset.done = '1';
      var bs = w.querySelectorAll('[data-k-btn]'), ops = w.querySelectorAll('[data-k]');
      bs.forEach(function (b) { b.addEventListener('click', function () { bs.forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); ops.forEach(function (o) { o.classList.toggle('on', o.dataset.k === b.dataset.kBtn); }); }); });
    });
  }
  // trui end
  function gpui(root) {
    (root || document).querySelectorAll('.mma [data-snav]').forEach(function (nav) {
      if (nav.dataset.done) return; nav.dataset.done = '1';
      var links = [].slice.call(nav.querySelectorAll('a')), secs = links.map(function (a) { return document.querySelector(a.getAttribute('href')); });
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) links.forEach(function (l) { l.classList.toggle('on', l.getAttribute('href') === '#' + e.target.id); }); }); }, { rootMargin: '-30% 0px -60% 0px' });
      secs.forEach(function (s) { if (s) io.observe(s); });
    });
    (root || document).querySelectorAll('.mma [data-gpqty]').forEach(function (q) {
      if (q.dataset.done) return; q.dataset.done = '1';
      var i = q.querySelector('input'), f = q.closest('form'), u = f && f.querySelector('[data-upd]');
      if (u) u.hidden = true;
      q.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { i.value = Math.max(0, (+i.value || 0) + (+b.dataset.d)); f.submit(); }); });
      i.addEventListener('change', function () { f.submit(); });
    });
  }
  // gpui end
  function vdui(root) {
    (root || document).querySelectorAll('.mma [data-vmenu]').forEach(function (m) {
      if (m.dataset.done) return; m.dataset.done = '1';
      var bs = [].slice.call(m.querySelectorAll('[role=tab]')), ps = [].slice.call(m.querySelectorAll('[role=tabpanel]'));
      bs.forEach(function (b, i) {
        b.addEventListener('click', function () { bs.forEach(function (x, j) { x.setAttribute('aria-selected', j === i); x.tabIndex = j === i ? 0 : -1; if (ps[j]) ps[j].hidden = j !== i; }); });
        b.addEventListener('keydown', function (e) { var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0; if (d) { e.preventDefault(); var n = bs[(i + d + bs.length) % bs.length]; n.click(); n.focus(); } });
      });
    });
    (root || document).querySelectorAll('.mma [data-tc]').forEach(function (t) {
      if (t.dataset.done || matchMedia('(prefers-reduced-motion: reduce)').matches) return; t.dataset.done = '1';
      var f = (1 * 60 + 24) * 25 + 12, p = function (n) { return String(n).padStart(2, '0'); };
      setInterval(function () { f++; var s = Math.floor(f / 25); t.textContent = '00:' + p(Math.floor(s / 60)) + ':' + p(s % 60) + ':' + p(f % 25); }, 40);
    });
  }
  // vdui end
  function init(root) { reveal(root); marquee(root); burgers(root); coverflow(root); pdp(root); blogs(root); crews(root); dltabs(root); rcshop(root); hubnav(root); pkqual(root); gcui(root); wegal(root); bsui(root); trui(root); gpui(root); vdui(root); rails(); header(); }
  document.addEventListener('DOMContentLoaded', function () { init(); });
  addEventListener('scroll', function () { rails(); header(); }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); e.target.querySelectorAll('.rv').forEach(function (x) { x.classList.add('in'); }); });
})();
